import { useContext } from "react";
import "./TopBar.scss";
import { Layout } from "antd";
import { ReactComponent as LogoIcon } from "../../assets/logo-icon.svg";
import { ProjectBreadcrumb } from "./ProjectBreadcrumb";
import { BurgerMenu } from "./BurgerMenu";
import { Link } from "react-router-dom";
import { PublishButtons } from "./PublishButtons";
import { UndoRedoButtons } from "./UndoRedoButtons";
import { MSTContext } from "../../stores/main";
import { observer } from "mobx-react-lite";
import { LayerInspectorModeSelector } from "./LayerInspectorModeSelector";

const { Header } = Layout;

type Props = {};

export const TopBar = observer((props: Props) => {
  const {
    platformStore: { selectedProjectId, allProjects },
  } = useContext(MSTContext);
  const selectedProjectExists = allProjects.find(
    (project) => project.id === selectedProjectId
  );

  // handle initial tab selection when project is selected
  // will remove this when we have a proper routing solution

  return (
    <Header className="playground-top-bar">
      <div className="left">
        <Link className="logo-link" to={"/"}>
          <LogoIcon className="logo-icon" />
        </Link>
        {selectedProjectExists && <ProjectBreadcrumb />}
        {selectedProjectExists && <UndoRedoButtons />}
      </div>

      <div className="right">
        {selectedProjectExists ? <LayerInspectorModeSelector /> : null}
        {selectedProjectExists ? <PublishButtons /> : null}
        <BurgerMenu />
      </div>
    </Header>
  );
});
